import React from "react";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gray-900 px-4 py-10">
      <div className="mx-auto max-w-3xl">
        <h1 className="mb-2 text-3xl font-bold text-white">Privacy Policy</h1>
        <p className="mb-8 text-sm text-gray-400">
          Last updated:{" "}
          {new Date().toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>

        <div className="space-y-6 text-gray-300">
          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              1. Introduction
            </h2>
            <p className="text-sm leading-relaxed">
              Cobutler (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;)
              respects your privacy. This Privacy Policy describes how we
              collect, use, and share information when you use our website and
              services (collectively, the &quot;Service&quot;).
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              2. Information we collect
            </h2>
            <p className="text-sm leading-relaxed">
              We may collect information you provide directly (such as account
              and contact details), information necessary to operate the Service
              (such as data related to your connected email account and how you
              use Cobutler), and technical data (such as device, browser, and
              log information). The scope of email-related data depends on the
              permissions you grant when you connect your account.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              3. How we use information
            </h2>
            <p className="text-sm leading-relaxed">
              We use information to provide, maintain, and improve the Service;
              to communicate with you about your account or the Service; to
              detect and prevent abuse or fraud; and to comply with legal
              obligations. We do not sell your personal information.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              4. Sharing and subprocessors
            </h2>
            <p className="text-sm leading-relaxed">
              We may share information with service providers who assist us in
              operating the Service (for example, hosting, analytics, or payment
              processing), subject to appropriate safeguards. We may also
              disclose information if required by law or to protect our rights
              and users.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              5. Data retention and security
            </h2>
            <p className="text-sm leading-relaxed">
              We retain information for as long as needed to provide the Service
              and for legitimate business and legal purposes. We implement
              reasonable technical and organizational measures to protect
              information; no method of transmission or storage is completely
              secure.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              6. Your choices and rights
            </h2>
            <p className="text-sm leading-relaxed">
              Depending on where you live, you may have rights to access,
              correct, delete, or restrict processing of your personal
              information, or to object to certain processing. You may contact
              us using the email below. You can also disconnect third-party
              integrations through your account settings where available.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              7. International transfers
            </h2>
            <p className="text-sm leading-relaxed">
              If you use the Service from outside the country where we operate,
              your information may be transferred to and processed in countries
              that may have different data protection laws.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              8. Changes to this policy
            </h2>
            <p className="text-sm leading-relaxed">
              We may update this Privacy Policy from time to time. We will post
              the updated policy on this page and revise the &quot;Last
              updated&quot; date. We encourage you to review this policy
              periodically.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              9. Contact
            </h2>
            <p className="text-sm leading-relaxed">
              For privacy-related questions, contact us at{" "}
              <a
                href="mailto:hello@cobutler.com"
                className="text-blue-400 hover:text-blue-300"
              >
                hello@cobutler.com
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
